// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "org_location_opening_hours_exception".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "org_location_opening_hours_exception" table (1:1 with a DB row, on the wire). */
export const organizationLocationOpeningHoursExceptionAtomSchema = z.object({
    id: z.string(),
    locationId: z.string(),
    date: z.string(),
    closed: z.boolean(),
    fromMinutes: z.number().nullable(),
    toMinutes: z.number().nullable(),
    note: z.string().nullable(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=organizationLocationOpeningHoursException.js.map